import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { SinistroTable } from '../components/sinistro/SinistroTable';
import SinistroModal from '../components/sinistro/SinistroModal';

const SinistrosPage: React.FC = () => {
  const [selectedSinistro, setSelectedSinistro] = useState<any>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);


  const handleEdit = (sinistro: any) => {
    setSelectedSinistro(sinistro);
    setReadOnly(false);
    setModalOpen(true);
  };

  const handleView = (sinistro: any) => {
    setSelectedSinistro(sinistro);
    setReadOnly(true);
    setModalOpen(true);
  };

  const handleSave = () => {
    setModalOpen(false);
    setSelectedSinistro(undefined);
    setReadOnly(false);
    setRefreshKey(k => k + 1);
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedSinistro(undefined);
    setReadOnly(false);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Gestão de Sinistros
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Gerencie os sinistros do sistema
              </p>
            </div>
            
            {/* botão de 'Novo Sinistro' removido — criação não disponível nesta página */}
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <SinistroTable
              onEdit={handleEdit}
              onView={handleView}
              refreshKey={refreshKey}
              onDeleted={() => setRefreshKey(k => k + 1)}
            />
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>

      {/* Modal de Formulário */}
      <SinistroModal
        isOpen={modalOpen}
        onClose={handleClose}
        sinistro={selectedSinistro}
        onSave={handleSave}
        readOnly={readOnly}
      />
    </div>
  );
};

export default SinistrosPage;
